import { ItReportTemplateResponse } from "../services/reportService";

export interface GroupedReports {
    [category: string]: ItReportTemplateResponse[];
}

/**
 * Groups reports by their category name
 * @param reports - Array of reports to group
 * @returns Object with categories as keys and report arrays as values
 */
export const groupReportsByCategory = (reports: ItReportTemplateResponse[]): GroupedReports => {
    return reports.reduce((groups: GroupedReports, report) => {
        // Use the category name from the report's category relationship
        const category = report.category_name || 'Uncategorized';

        if (!groups[category]) {
            groups[category] = [];
        }

        groups[category].push(report);
        return groups;
    }, {});
};

/**
 * Sort categories alphabetically
 * @param categories - Array of category names
 * @returns Sorted array of category names
 */
export const sortReportCategories = (categories: string[]): string[] => {
    // Sort alphabetically, with "Uncategorized" at the end
    return categories.sort((a, b) => {
        if (a === 'Uncategorized') return 1;
        if (b === 'Uncategorized') return -1;
        return a.localeCompare(b);
    });
};

/**
 * Get report IDs for a category
 * @param categoryReports - Reports in the category
 * @returns Array of report IDs in the category
 */
export const getCategoryReportIds = (categoryReports: ItReportTemplateResponse[]): number[] => {
    return categoryReports.map(report => report.id || 0).filter(id => id !== 0);
};
